"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkWithParamsHOC = exports.LinkHOC = exports.Button = exports.Picture = exports.Row = exports.Image = exports.TextOnImageCol = exports.ExtraMarginCol = exports.Description = exports.Title = exports.TextContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../UI/Typography"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Button_1 = __importDefault(require("../../Button"));
const Types_1 = require("Types");
const BodyText_1 = __importDefault(require("../../UI/BodyText"));
exports.TextContainer = styled_components_1.default.div `
  position: relative;
  ${props => (props.textAlignment === Types_1.TextAlignment.CENTER ? 'text-align: center;' : null)}
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  margin: ${props => props.theme.spacing.s4}px 0 0 0;
`;
exports.Description = (0, styled_components_1.default)(BodyText_1.default) `
  color: ${props => props.theme.palette.DARK_GRAY_100};
  font-size: ${props => props.theme.typography.size.defaultSize}px;
  line-height: ${props => props.theme.typography.lineHeight.m2}px;
  margin-top: ${props => props.theme.spacing.s4}px;

  > h5 {
    margin: 0 0 ${props => props.theme.spacing.s2}px 0;
  }

  ${props => props.textOnImage
    ? `font-weight: ${props.theme.typography.weight.light}; margin-top: 0; color: ${props.theme.palette.BW_100};`
    : null}
`;
const StyledDiv = styled_components_1.default.div `
  box-sizing: border-box;
  position: relative;
`;
exports.ExtraMarginCol = (0, styled_components_1.default)(StyledDiv) `
  ${props => props.link && `cursor: pointer;`}
  margin-top: ${props => props.theme.spacing.xl1}px;
  ${props => (props.extraMargin ? `margin-bottom: ${props.theme.spacing.s5}px` : null)}
  ${props => props.isPromo
    ? 'margin-top: 0;'
    : props.columns === 3 &&
        `
      margin-top: ${props.theme.spacing.s4}px;
      @media (max-width: ${props.theme.breakpoints.lg}px) {
        margin-top: ${props.theme.spacing.m5}px;
      }
      @media (max-width: ${props.theme.breakpoints.md}px) {
        margin-top: ${props.theme.spacing.m4}px;
      }
  `}
`;
exports.TextOnImageCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  box-sizing: border-box;
  position: relative;
  ${props => props.textOnImage
    ? `
      background: ${props.theme.palette.GR_BLUE};
      position: absolute;
      padding: ${props.theme.spacing.m2}px ${props.theme.spacing.m6}px ${props.theme.spacing.m5}px ${props.theme.spacing.m3}px;
      bottom: -${props.theme.spacing.s5}px;
      left: -${props.theme.spacing.s5}px;
      `
    : null}}
`;
exports.Image = styled_components_1.default.img `
  object-fit: cover;
  width: 100%;
`;
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  justify-content: center;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    gap: ${props => props.theme.spacing.l2}px;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin: 0 -${props => props.theme.constants.paddings.sm}px;
  }
`;
exports.Picture = styled_components_1.default.picture `
  display: flex;
  height: ${props => props.height}px;
`;
exports.Button = (0, styled_components_1.default)(Button_1.default) `
  margin-top: ${props => props.theme.spacing.s2}px;
`;
exports.LinkHOC = styled_components_1.default.a `
  display: contents;
`;
exports.LinkWithParamsHOC = styled_components_1.default.div `
  display: contents;
`;
exports.default = {
    TextContainer: exports.TextContainer,
    Title: exports.Title,
    Image: exports.Image,
    Row: exports.Row,
    Picture: exports.Picture,
    Button: exports.Button,
    LinkHOC: exports.LinkHOC,
    LinkWithParamsHOC: exports.LinkWithParamsHOC
};
